import { Popover, Skeleton } from "antd";
import { styled } from "styled-components";
import { PopoverContent } from "../popover/PopoverContent";
import { QUERIES, getSearchHistory, scrollBarStyles } from "@dataone/lib";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { ThreeDotsIcon, TimingIcon } from "@dataone/icons";

interface HistoryProps {
  setSelectedSearch: React.Dispatch<React.SetStateAction<{ message: string }>>;
}

const History = ({ setSelectedSearch }: HistoryProps) => {
  const { data: history, isLoading } = useQuery({
    queryKey: [QUERIES.SEARCH_HISTORY],
    queryFn: getSearchHistory,
  });

  return (
    <StyledHistory>
      {isLoading ? (
        <HistoryLoading>
          <Skeleton.Input active block size="small" />
          <Skeleton.Input active block size="small" />
          <Skeleton.Input active block size="small" />
        </HistoryLoading>
      ) : (
        history?.content.slice(0, 3).map((search) => (
          <StyledContainer key={search.id}>
            <span className="timing-icon">
              <TimingIcon />
            </span>
            <div
              className="search-desc"
              onClick={() => setSelectedSearch({ message: search.message })}
            >
              {search.message}
            </div>
            <div className="dots-icon">
              <div
                style={{
                  clear: "both",
                  whiteSpace: "nowrap",
                }}
              >
                <Popover
                  getTooltipContainer={(trigger) =>
                    trigger.parentNode as HTMLElement
                  }
                  placement="bottomLeft"
                  content={<PopoverContent search={search} action="Saved" />}
                  trigger="click"
                >
                  <span className="three-dots-icon">
                    <ThreeDotsIcon />
                  </span>
                </Popover>
              </div>
            </div>
          </StyledContainer>
        ))
      )}
    </StyledHistory>
  );
};

export default History;

const StyledContainer = styled.div`
  margin-top: 6px;
  display: flex;
  flex-direction: row;
  padding: 4px 0px;
  cursor: pointer;
  align-items: center;
  &:hover {
    background: #fff;
  }

  .dots-icon {
    margin-right: 15px;
  }
  .timing-icon {
    margin: 0px 10px 0px 20px;
    display: flex;
    width: 20px;
  }
  .search-desc {
    color: #000;
    font-size: 14px;
    font-weight: 300;
    flex: 1;
    max-width: 91%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .three-dots-icon {
    cursor: pointer;
    display: flex;
  }

  .ant-popover {
    z-index: 5;
  }
`;

const StyledHistory = styled.div`
  // overflow-y: auto;
  max-height: 150px;
  margin: 8px 0px 20px 0px;
  // ${scrollBarStyles}
`;

const HistoryLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px;
`;
